import Icon from 'veui/components/Icon'

Icon.register({
  planet: {
    paths: [
      {
        d: 'M681.63 92.37C656.56 67.3 622.55 63 598.46 63.81c-27.77.93-59.58 8.79-94.6 23.32A320.34 320.34 0 0087.13 503.86c-14.53 35-22.39 66.83-23.32 94.6-1.46 43.67 14.72 69.33 28.56 83.17 13.34 13.33 37.43 28.65 77.73 28.65q4.07 0 8.37-.21c28.33-1.43 60.69-9.89 96.27-25.13a320.4 320.4 0 00410.2-410.2c15.24-35.58 23.7-67.94 25.13-96.27 2.28-45.37-14.21-71.86-28.44-86.1zM203 203a256.31 256.31 0 01412 70.4c-31.47 62.75-82.9 131.26-146.63 195S336.13 583.53 273.38 615A256.13 256.13 0 01203 203zm-65.37 433.37c-10.12-10.12-12.42-30.54-7.28-57.22a324.69 324.69 0 0066.14 64.22c-27.49 5.63-48.49 3.41-58.86-7zM565 565a254.33 254.33 0 01-181 75q-12 0-23.84-1.1c51.38-33 104-75.78 153.47-125.27s92.29-102.09 125.27-153.47Q640 372 640 384a254.33 254.33 0 01-75 181zm45.25-407.29a323.58 323.58 0 00-31.12-27.38c26.68-5.14 47.1-2.84 57.22 7.28 10.41 10.4 12.59 31.39 7 58.86a323.79 323.79 0 00-33.08-38.74z'
      }
    ],
    width: '768',
    height: '768'
  }
})
